/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import GeneralInfo from "./components/GeneralInfo/GeneralInfo";
import WarehouseTruckList from "./components/WarehouseTruckList/WarehouseTruckList";
import { loadSingleWarehouse } from "../WarehouseList/WarehouseList.actionCreators";
import "react-tooltip/dist/react-tooltip.css";
import WarehouseAction from "../WarehouseList/components/WarehouseAction/WarehouseAction";
import {
  CenterProductViewContainer,
  FlexRow,
  SectionContainer,
  GridRow,
  BreadCrumb,
  ProductTitle,
  ButtonWrapper,
  ButtonData,
  ParentDetail,
} from "./WarehouseView.styled";
import "./WarehouseView.scss";
import NotFound from "@components/Errors/NotFound";
import { setSingleWarehouseNotFound } from "../WarehouseList/WarehouseList.slice";

/**
 * Warehouse View,
 * Path - /companies/{companyId}/hauliers/{haulierId}/warehouses/{warehouseId}
 * @see See [WarehouseView Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2951905281/Company+view+page+-+Warehouse+view+page)
 * @component
 */
const WarehouseView = (props) => {
  const { t } = props;
  const history = useNavigate();
  const location = useLocation();
  const isWarehousePath = /^\/company\/view\/\d+\/warehouse\/view\/\d+$/.test(
    location.pathname
  );
  const [isRefreshWarehouse, setIsRefreshWarehouse] = useState(false);
  const [warehouseData, setWarehouseData] = useState([]);
  const [selectedCompanyData, setSelectedCompanyData] = useState([]);
  const params = useParams();
  const { warehouseId } = params;

  const companyId = params.id;

  const warehouseInfo = useSelector(
    (state) => state.warehouseList.byId[warehouseId]
  );

  const selectedwarehouseData = useSelector(
    (state) => state.warehouseList.selectedWarehouse
  );

  const companyInfo = useSelector(
    (state) => state.companyList.byId[parseInt(params.id)]
  );

  const singleCompanyInfo = useSelector(
    (state) => state.companyList.selectedCompany
  );

  const isSingleCompanyNotFound = useSelector(
    (state) => state.companyList.isSingleCompanyNotFound
  );

  const isSingleWarehouseNotFound = useSelector(
    (state) => state.warehouseList.isSingleWarehouseNotFound
  );

  useEffect(() => {
    if (
      companyInfo !== undefined &&
      parseInt(companyId, 10) === parseInt(companyInfo.id, 10)
    ) {
      setSelectedCompanyData(companyInfo);
    }
    if (
      singleCompanyInfo !== null &&
      parseInt(companyId, 10) === parseInt(singleCompanyInfo.id, 10)
    ) {
      setSelectedCompanyData(singleCompanyInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyInfo, singleCompanyInfo]);

  const haulierId = selectedCompanyData?.haulier?.id;
  const dispatch = useDispatch();

  const fetcheWarehouseInfo = () => {
    dispatch(
      loadSingleWarehouse({
        companyId,
        haulierId,
        warehouseId,
      })
    );
  };

  const updateRefeshStatus = () => {
    setIsRefreshWarehouse(true);
  };

  useEffect(() => {
    if (isRefreshWarehouse) {
      setIsRefreshWarehouse(false);
    }
  }, [isRefreshWarehouse]);
  
  useEffect(() => {
    dispatch(setSingleWarehouseNotFound(false));
    if (
      warehouseInfo === undefined &&
      parseInt(warehouseId, 10) !== parseInt(warehouseInfo?.id, 10) &&
      parseInt(selectedCompanyData?.id, 10) === parseInt(companyId, 10)
    ) {
      fetcheWarehouseInfo();
    }
  }, [warehouseInfo, selectedCompanyData]);

  useEffect(() => {
    if (isRefreshWarehouse) {
      fetcheWarehouseInfo();
    }
  }, [isRefreshWarehouse]);

  useEffect(() => {
    if (
      warehouseInfo !== undefined &&
      parseInt(warehouseId, 10) === parseInt(warehouseInfo.id, 10)
    ) {
      setWarehouseData(warehouseInfo);
    }
    if (
      selectedwarehouseData !== null &&
      parseInt(warehouseId, 10) === parseInt(selectedwarehouseData.id, 10)
    ) {
      setWarehouseData(selectedwarehouseData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [warehouseInfo, selectedwarehouseData]);

  const updateWarehouseInfo = (updatedWarehouseInfo) => {
    setWarehouseData(updatedWarehouseInfo);
  };

  if (
    !isWarehousePath ||
    isSingleWarehouseNotFound ||
    isSingleCompanyNotFound
  ) {
    return <NotFound />;
  }

  return (
    <CenterProductViewContainer>
      {warehouseData?.id && (
        <>
          <FlexRow>
            <SectionContainer>
              <GridRow column="1fr 1fr" marginBottom="15px">
                <BreadCrumb>
                  <Link
                    to={`/company/view/${companyId}/warehouses`}
                    className="warehouse-view__link"
                  >
                    {"<"}
                    {t("GENERAL_BACK_TO_LIST")}
                  </Link>
                </BreadCrumb>
                {!!selectedCompanyData?.status && (
                  <WarehouseAction
                    data={warehouseData}
                    companyId={companyId}
                    countryId={selectedCompanyData?.platformCountryId}
                    updateWarehouseInfo={updateWarehouseInfo}
                    companyStatus={selectedCompanyData?.status}
                    carrierId={haulierId}
                    isUpdateState
                    updateRefeshStatus={updateRefeshStatus}
                  />
                )}
              </GridRow>
              <GridRow column="1fr 1fr">
                <ProductTitle>
                  # {warehouseData.id}
                  {warehouseData.name ? " - " + warehouseData.name : ""}
                </ProductTitle>
                <ButtonWrapper>
                  <ButtonData
                    color={
                      warehouseData.status === true ? "#32A728" : "#E83F1E"
                    }
                  >
                    {warehouseData.status === true
                      ? t("ACTIVE")
                      : t("INACTIVE")}
                  </ButtonData>
                </ButtonWrapper>
              </GridRow>
              <GridRow column="1fr" marginTop="-20px">
                <ParentDetail>
                  {t("WAREHOUSE_BELONGS_TO")}&nbsp;
                  <Link
                    className="warehouse-view__parent-link"
                    to={`/company/view/${companyId}/general-info`}
                  >
                    # {companyId + "-" + (selectedCompanyData?.name || "")}
                  </Link>
                </ParentDetail>
              </GridRow>
              <GeneralInfo data={warehouseData} />
              <WarehouseTruckList
                setIsRefreshWarehouse={setIsRefreshWarehouse}
                isRefreshWarehouse={isRefreshWarehouse}
                carrierId={haulierId}
                warehouseData={warehouseData}
                companyId={companyId}
                countryId={selectedCompanyData?.platformCountryId}
                companyStatus={selectedCompanyData?.status}
                companyName={selectedCompanyData?.name || ""}
              />
            </SectionContainer>
          </FlexRow>
        </>
      )}
    </CenterProductViewContainer>
  );
};

WarehouseView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(WarehouseView);
